export enum DateFormatOptions {
  DayMonthYear = 'dd-MM-yyyy',
  MonthDayYear = 'MM-dd-yyyy',
}

export const dateFormatOptionToLabelMap: Record<DateFormatOptions, string> = {
  [DateFormatOptions.DayMonthYear]: 'DD-MM-YYYY',
  [DateFormatOptions.MonthDayYear]: 'MM-DD-YYYY',
};

export const initialDateFormat = DateFormatOptions.DayMonthYear;

export enum TimeFormatOptions {
  Military = 'HH:mm',
  Standard = 'h:mm a',
}

export const timeFormatOptionToLabelMap: Record<TimeFormatOptions, string> = {
  [TimeFormatOptions.Standard]: '1:00 pm',
  [TimeFormatOptions.Military]: '13:00',
};

export const fullCalendarStandardTime = {
  hour: 'numeric' as 'numeric',
  minute: '2-digit' as '2-digit',
  omitZeroMinute: false,
  meridiem: 'short' as 'short',
  hour12: true,
};

export const fullCalendarMilitaryTime = {
  hour: '2-digit' as '2-digit',
  minute: '2-digit' as '2-digit',
  hour12: false,
};

export const initialTimeFormat = TimeFormatOptions.Military;

// Regex pattern for AM/PM variations in standard time format
// Supports: AM, am, A.M., a.m., etc.
export const AM_PM_REGEX =
  /\s*(a\.m\.|p\.m\.|am|pm|a\.m|p\.m|AM|PM|A\.M\.|P\.M\.|A\.M|P\.M)\.?/i;

// Regex pattern for validating standard time format with AM/PM
export const STANDARD_TIME_REGEX = new RegExp(
  `^(0?[1-9]|1[0-2]):([0-5]\\d) ${AM_PM_REGEX.source}$`,
  'i',
);

// Regex pattern for validating military time format
export const MILITARY_TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
